import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { INVOICE_LEVEL_DISCOUNT_COLUMNS } from './DiscountTable.config';
import styles from './DiscountTable.styles.scss';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

const DiscountTable = ({ documentDiscount }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={cn(styles['table-header'])}>
        <span>{t('createInvoice.discount')}</span>
        <span>
          {Number(
            documentDiscount.reduce(
              (acc, item) => acc + Number(item.discountAmount),
              0,
            ),
          ).toFixed(3) + ' BHD'}
        </span>
      </div>
      <div className={styles['table-container']}>
        <DataTable
          scrollable
          scrollHeight="400px"
          value={documentDiscount}
          tableStyle={{ minWidth: '50rem' }}
          className={styles['document-discount-datatable']}
        >
          {INVOICE_LEVEL_DISCOUNT_COLUMNS.map((col, i) => (
            <Column
              className={styles['table-columns']}
              key={col.key}
              field={col.key}
              body={col.body}
              header={t(col.label)}
              minWidth={'50rem'}
            />
          ))}
        </DataTable>
      </div>
    </div>
  );
};

export default React.memo(DiscountTable);
